import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import THEME from '../../constants/theme';

const ProjectSelector = ({
  selectedProject,
  projectOptions,
  onSelectProject
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = project => {
    onSelectProject(project);
    handleClose();
  };

  return (
    <>
      <Button
        variant='outlined'
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          color: THEME.COLORS.PRIMARY_BLUE,
          borderColor: THEME.COLORS.PRIMARY_BLUE,
          borderWidth: 2,
          textTransform: 'none',
          fontSize: { xs: '1.1rem', sm: '1.2rem' },
          fontWeight: THEME.TYPOGRAPHY.FONT_WEIGHT.MEDIUM,
          fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.PRIMARY,
          padding: { xs: '8px 16px', sm: '10px 20px' },
          borderRadius: '8px',
          '&:hover': {
            borderColor: THEME.COLORS.PRIMARY_BLUE,
            borderWidth: 2,
            backgroundColor: 'rgba(0, 112, 243, 0.04)'
          }
        }}
      >
        Viewing factsheets for {selectedProject}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        sx={{
          mt: 1
        }}
      >
        {projectOptions.map(option => (
          <MenuItem
            key={option.value}
            onClick={() => handleSelect(option.label)}
            selected={option.label === selectedProject}
            sx={{
              fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.PRIMARY,
              fontSize: '1rem',
              '&.Mui-selected': {
                backgroundColor: 'rgba(0, 112, 243, 0.08)',
                '&:hover': {
                  backgroundColor: 'rgba(0, 112, 243, 0.12)'
                }
              }
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ProjectSelector;
